var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1C16.1826 1 19.2348 2.26428 21.4853 4.51472C23.7357 6.76515 25 9.8174 25 13C25 16.1826 23.7357 19.2348 21.4853 21.4853C19.2348 23.7357 16.1826 25 13 25C9.8174 25 6.76515 23.7357 4.51472 21.4853C2.26428 19.2348 1 16.1826 1 13C1 9.8174 2.26428 6.76515 4.51472 4.51472C6.76515 2.26428 9.8174 1 13 1Z",
    fill: "#2FA136"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1C16.1826 1 19.2348 2.26428 21.4853 4.51472C23.7357 6.76516 25 9.8174 25 13C25 16.1826 23.7357 19.2348 21.4853 21.4853C19.2348 23.7357 16.1826 25 13 25C9.8174 25 6.76516 23.7357 4.51472 21.4853C2.26428 19.2348 1 16.1826 1 13V13C1 9.8174 2.26428 6.76516 4.51472 4.51472C6.76516 2.26428 9.8174 1 13 1V1Z",
    stroke: "#094E0B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8332 13.0003C18.8332 13.4606 18.4601 13.8337 17.9998 13.8337H14.8332C14.2809 13.8337 13.8332 14.2814 13.8332 14.8337V18.0003C13.8332 18.4606 13.4601 18.8337 12.9998 18.8337C12.5396 18.8337 12.1665 18.4606 12.1665 18.0003V14.8337C12.1665 14.2814 11.7188 13.8337 11.1665 13.8337H7.99984C7.5396 13.8337 7.1665 13.4606 7.1665 13.0003C7.1665 12.5401 7.5396 12.167 7.99984 12.167H11.1665C11.7188 12.167 12.1665 11.7193 12.1665 11.167V8.00033C12.1665 7.54009 12.5396 7.16699 12.9998 7.16699C13.4601 7.16699 13.8332 7.54009 13.8332 8.00033V11.167C13.8332 11.7193 14.2809 12.167 14.8332 12.167H17.9998C18.4601 12.167 18.8332 12.5401 18.8332 13.0003Z",
    fill: "#FFFBF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBadge);
export default __webpack_public_path__ + "static/media/add-badge.2c03b04ff6fa571e2bfe699082c322e4.svg";
export { ForwardRef as ReactComponent };